import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appThrottleClick]',
})

/**
 * Custom and generic throttle click directive
 */
export class ThrottleClickDirective implements OnInit, OnDestroy {
  @Input() throttleTime = 500;
  @Output() throttleClick = new EventEmitter();
  private clicks = new Subject();
  private subscription!: Subscription;

  /**
   * on init
   */
  ngOnInit() {
    this.subscription = this.clicks
      .pipe(throttleTime(this.throttleTime))
      .subscribe((e) => this.throttleClick.emit(e));
  }

  /**
   * on destroy
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Holds click event
   * @param {any} event
   */
  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
